export default __webpack_public_path__ + "static/media/review2.b8dce8ce.png";